<main class="account-deletion d-flex justify-content-center align-items-start py-5 px-3">
  <article class="deletion-card w-100">
    <header class="mb-4">
      <h1 class="h3 mb-0">
        <b>Delete Your {{ partnerName }} Account</b>
      </h1>
    </header>

    <!-- STEP 1: Request verification code -->
    <ng-container *ngIf="step === 'request'">
      <section class="mb-4">
        <h2 class="h5 text-gray">What gets deleted</h2>
        <p class="text-gray mb-2">
          Once your request is verified, the following data is
          <b>permanently deleted within 30 days</b>:
        </p>
        <ul class="text-gray">
          <li>Your profile information</li>
          <li>Your login credentials</li>
          <li>Your saved beneficiaries and recipients</li>
          <li>Your personal preferences</li>
        </ul>
      </section>

      <section class="mb-4">
        <h2 class="h5 text-gray">What is retained and why</h2>
        <p class="text-gray mb-0">
          Your transaction history and identity-verification (KYC/AML) records
          are retained for <b>{{ dataRetentionYears }} years</b> as required by
          applicable anti-money-laundering and financial regulations, after
          which they are deleted. These retained records are kept solely to meet
          legal and regulatory obligations and are
          <b>not used for any other purpose</b>.
        </p>
      </section>

      <section class="mb-4">
        <h2 class="h5 text-gray">Request deletion</h2>
        <p class="text-gray mb-3">
          Enter your <b>registered email address</b>. We will send a
          verification code to that email to confirm it is really you.
        </p>

        <form [formGroup]="requestForm" (ngSubmit)="onRequestCode()" autocomplete="off">
          <div class="mb-3">
            <label for="email" class="form-label text-gray">Email address</label>
            <input
              id="email"
              type="email"
              class="form-control"
              formControlName="email"
              placeholder="you@example.com" />
            <small
              class="text-danger d-block mt-1"
              *ngIf="
                requestForm.get('email')?.touched &&
                requestForm.get('email')?.invalid
              ">
              Please enter a valid email address.
            </small>
          </div>

          <p class="text-danger mb-3" *ngIf="errorMessage">{{ errorMessage }}</p>

          <button
            type="submit"
            class="btn primary-btn w-100"
            [disabled]="isLoading">
            {{ isLoading ? 'Sending…' : 'Send verification code' }}
          </button>
        </form>
      </section>

      <section>
        <h2 class="h5 text-gray">Need help</h2>
        <p class="text-gray mb-0">
          If you have any questions, contact us at
          <a [href]="mailtoLink">{{ supportEmail }}</a>.
        </p>
      </section>
    </ng-container>

    <!-- STEP 2: Confirm deletion -->
    <ng-container *ngIf="step === 'confirm'">
      <section class="mb-4">
        <h2 class="h5 text-gray">Confirm account deletion</h2>
        <p class="text-gray mb-2">
          We sent a verification code to <b>{{ submittedEmail }}</b>. Enter the
          code below to permanently delete your account.
        </p>

        <form [formGroup]="confirmForm" (ngSubmit)="onConfirmDeletion()" autocomplete="off">
          <div class="mb-3">
            <label for="verification_code" class="form-label text-gray">
              Verification code
            </label>
            <input
              id="verification_code"
              type="text"
              inputmode="numeric"
              class="form-control"
              formControlName="verification_code"
              placeholder="Enter the code from your email" />
            <small
              class="text-danger d-block mt-1"
              *ngIf="
                confirmForm.get('verification_code')?.touched &&
                confirmForm.get('verification_code')?.invalid
              ">
              Please enter the verification code.
            </small>
          </div>

          <div class="form-check mb-3">
            <input
              id="confirmation"
              type="checkbox"
              class="form-check-input"
              formControlName="confirmation" />
            <label for="confirmation" class="form-check-label text-gray">
              I understand my account will be permanently deleted and this cannot
              be undone.
            </label>
          </div>

          <p class="text-danger mb-3" *ngIf="errorMessage">{{ errorMessage }}</p>

          <button
            type="submit"
            class="btn danger-btn w-100"
            [disabled]="isLoading || confirmForm.invalid">
            {{ isLoading ? 'Deleting…' : 'Delete my account' }}
          </button>
        </form>

        <p class="text-gray mt-3 mb-0">
          Didn't get a code?
          <a
            href="javascript:void(0)"
            class="resend-link"
            (click)="onResendCode()">
            Resend code
          </a>
        </p>
      </section>

      <section>
        <h2 class="h5 text-gray">Need help</h2>
        <p class="text-gray mb-0">
          If you have any questions, contact us at
          <a [href]="mailtoLink">{{ supportEmail }}</a>.
        </p>
      </section>
    </ng-container>

    <!-- STEP 3: Done -->
    <ng-container *ngIf="step === 'done'">
      <section class="mb-4">
        <h2 class="h5 text-gray">Your account has been deleted</h2>
        <p class="text-gray mb-2">
          Your {{ partnerName }} account has been permanently deleted. Personal
          data has been removed or anonymised.
        </p>
        <p class="text-gray mb-0">
          As noted earlier, transaction history and identity-verification
          (KYC/AML) records are retained for
          <b>{{ dataRetentionYears }} years</b> to meet legal and regulatory
          obligations, after which they are deleted.
        </p>
      </section>

      <section>
        <h2 class="h5 text-gray">Need help</h2>
        <p class="text-gray mb-0">
          If you have any questions, contact us at
          <a [href]="mailtoLink">{{ supportEmail }}</a>.
        </p>
      </section>
    </ng-container>
  </article>
</main>
